import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const About: React.FC = () => {
  const features = [
    'Atendimento personalizado e humanizado',
    'Equipamentos de última geração',
    'Profissional qualificada e experiente',
    'Ambiente confortável e acolhedor',
  ];

  return (
    <Box id="about" sx={{ py: 10, bgcolor: 'white' }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              component="h2"
              gutterBottom
              sx={{ fontWeight: 700, color: '#9c4f96' }}
            >
              Sobre Nós
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
              A Dra. Thayne Silva Prado é uma cirurgiã dentista dedicada a proporcionar
              o melhor atendimento odontológico para você e sua família. 
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
              Com registro CRO/PR 38004, oferecemos uma ampla gama de serviços
              odontológicos, sempre priorizando o conforto e a satisfação dos nossos pacientes.
            </Typography>
            <Box sx={{ mt: 4 }}>
              {features.map((feature, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <CheckCircle sx={{ color: '#9c4f96', mr: 2 }} />
                  <Typography variant="body1">{feature}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;